import React from 'react';
export default (function (props) { return (React.createElement("a", { href: "#search", className: props.className, "aria-label": "search term", onClick: function (e) {
        e.preventDefault();
        props.onClick();
    } },
    React.createElement("span", { className: "cb-glyph cb-search" }))); });
